export class Session {
    token: string;
}